<div class="history-container">
  <h2>Historial de documentos</h2>

  <table class="history-table">
    <thead>
      <tr>
        <th>Fecha</th>
        <th>Tipo</th>
        <th>Tipo de creacion</th>
        <th>Estado</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of paginatedDocuments">
        <td>{{ doc.formUpdatedAt.slice(0, 10) }}</td>
        <td>{{ documentTypes[doc.menuId] || 'Tipo desconocido' }}</td>
        <td>{{ typeCreation[doc.typeRecord] || ''}}</td>
        <td>{{ statusLabels[doc.formStatus] || 'Estado desconocido' }}</td>
        <td class="action-buttons">
          <button class="generate-btn" (click)="generateDocument(doc)" [disabled]="isGenerateDisabled(doc)">Generar</button>
          <button class="modify-btn" (click)="modifyDocument(doc)" [disabled]="isModifyDisabled(doc)">Modificar</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pagination-container">
    <button (click)="previousPage()" [disabled]="currentPage === 1">Regresar</button>
    <span *ngFor="let page of totalPagesArray; let i = index">
      <a (click)="goToPage(i + 1)" [class.active]="currentPage === (i + 1)">{{ i + 1 }}</a>
    </span>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente</button>
  </div>
</div>
